/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_NoInputs */

const en_us2_workout_after_no = /** @type {(inputs: Workout_After_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const pt_br2_workout_after_no = /** @type {(inputs: Workout_After_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não`)
};

const es_419_workout_after_no = /** @type {(inputs: Workout_After_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const pt_pt2_workout_after_no = /** @type {(inputs: Workout_After_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não`)
};

const fr_fr2_workout_after_no = /** @type {(inputs: Workout_After_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non`)
};

const de_de2_workout_after_no = /** @type {(inputs: Workout_After_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein`)
};

const it_it2_workout_after_no = /** @type {(inputs: Workout_After_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

/**
* | output |
* | --- |
* | "No" |
*
* @param {Workout_After_NoInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_no = /** @type {((inputs?: Workout_After_NoInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_NoInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_no(inputs)
	if (locale === "es-419") return es_419_workout_after_no(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_no(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_no(inputs)
	if (locale === "de-DE") return de_de2_workout_after_no(inputs)
	if (locale === "it-IT") return it_it2_workout_after_no(inputs)
	return en_us2_workout_after_no(inputs)
});
export { workout_after_no as "workout-after.no" }